const { whatsappLinkStyle } = require("./functions/util");
const { whatsappStyles } = require("./functions/util");

export default function formatWppMarkdown(refElement) {
    if (refElement.current !== undefined) {
        if (refElement.current !== null) {
            let format = refElement.current.innerText;
            format = whatsappStyles(format, "_", "<i>", "</i>");
            format = whatsappStyles(format, "*", "<b>", "</b>");
            format = whatsappStyles(format, "~", "<s>", "</s>");
            format = format.replace(/\n/gi, "<br>");

            refElement.current.innerHTML = format;
            whatsappLinkStyle(refElement);
        }
    } else {
        let allItems = Array.from(document.querySelectorAll(refElement));

        if (allItems.length > 0) {
            allItems.map((item) => {
                let format = item.innerText;

                format = whatsappStyles(format, "_", "<i>", "</i>");
                format = whatsappStyles(format, "*", "<b>", "</b>");
                format = whatsappStyles(format, "~", "<s>", "</s>");
                format = format.replace(/\n/gi, "<br>");

                item.innerHTML = format;

                whatsappLinkStyle(allItems);
            });
        }
    }
}